const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zM7.45 17.24a.81.81 0 0 1-.72.41.92.92 0 0 1-.43-.11.83.83 0 0 1-.3-1.13L6.82 15a.48.48 0 0 1 .4-.23h.12a1.2 1.2 0 0 1 1.14.7zm6.93-2.68H5.45a.83.83 0 0 1-.83-.82.84.84 0 0 1 .86-.79h2.58l3.07-5.25-.99-1.7a.83.83 0 1 1 1.38-.93.25.25 0 0 1 0 .07l.54.91.53-.91a.83.83 0 1 1 1.46.86l-1 1.69-1 1.64L10 12.92h3.09a1.33 1.33 0 0 1 1.07.54 1.39 1.39 0 0 1 .27.79.71.71 0 0 1-.06.28zm4.17 0h-1.46l1.07 1.8a.86.86 0 0 1-.28 1.16.82.82 0 0 1-.43.12.84.84 0 0 1-.72-.41l-1.57-2.67-1-1.66-1.26-2.15a2.09 2.09 0 0 1 0-2 1.81 1.81 0 0 1 .44-.55l2.8 4.73h2.41a.83.83 0 1 1 0 1.66z",
    style: {
      fill: "#0074df"
    },
    "data-name": "Group 21120"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.340498584db81a7fbaf09568225788ee.svg";
export { ForwardRef as ReactComponent };